import {Table, TableBody, TableHead, makeStyles} from '@material-ui/core';
import React from 'react';
import {useSelector} from 'react-redux';
import {AvailRow, ErrorRow} from './results-row';
import {AVAIL_ENDPOINT, AVAIL_ERRORS_ENDPOINT} from '../../../../helpers/constants';
import ResultsHeader from './results-header';

const useStyles = makeStyles(theme => ({
  mainTableWrapper: {
    padding: theme.spacing(1),
  },
  mainTable: {
    tableLayout: 'fixed',
    width: '100%',
  },

  selectLimit: {
    width: '100px',
  },
}));

const ResultsSection = () => {
  const classes = useStyles();

  const {results, endpoint, params, searchType} = useSelector(state => state?.results);

  const {page, limit} = params;

  const renderRows = resultsCollection =>
    resultsCollection.map((result, rowIndex) =>
      AVAIL_ENDPOINT === endpoint ? (
        <AvailRow avail={result} key={rowIndex + result.alid + searchType + page + limit} />
      ) : AVAIL_ERRORS_ENDPOINT === endpoint ? (
        <ErrorRow error={result} key={rowIndex + searchType + page + limit} />
      ) : (
        ''
      )
    );

  return (
    results.length > 0 && (
      <>
        <ResultsHeader />
        <div className={classes.mainTableWrapper}>
          <Table className={classes.mainTable}>
            <TableHead />
            <TableBody>{renderRows(results)}</TableBody>
          </Table>
        </div>
      </>
    )
  );
};

export default ResultsSection;
